export const errorMessage = 'Failed to create an user saved project from perseus';
